import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';

const RDTag = ({ tagStyles, label, closable, onClose, isTagVisible, tagColor }) => (
  <Tag
    style={tagStyles}
    closable={closable}
    onClose={onClose}
    visible={isTagVisible}
    color={tagColor}
  >
    {label}
  </Tag>
);

RDTag.defaultProps = {
  tagStyles: {},
  label: '',
  closable: true,
  onClose: () => {},
  isTagVisible: true,
  tagColor: '',
};

RDTag.propTypes = {
  /** Tag Content */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Whether the Tag can be closed */
  closable: PropTypes.bool,
  /** Callback executed when tag is closed */
  onClose: PropTypes.func,
  /** Whether the Tag is closed or not */
  isTagVisible: PropTypes.bool,
  /** Color of the Tag */
  tagColor: PropTypes.string,
  /** Tag placeholder */
  tagStyles: PropTypes.shape({}),
};

export default RDTag;
